<template>
    <div class="verAddCon"  v-if='showModel' ref='verAddConRef' >

        <div class="mainTitle flexBC" style="">

            <div class="mainTitle">
                <span>{{title}}</span>
                <Icon type="md-refresh" style="margin-left:30px;cursor: pointer;" :title="$t('update')" @click="getData" />
                <Button type="primary" class="addButton" @click="showAdminData" style="margin-left:20px;margin-right:20px;">{{$t("BasicProduct.funcBox.sync")}}</Button>
            </div>
            <div class="mainTitle">
                <Button type="info" class="addButton" @click="importData" style="margin-right:8px;">{{$t("BasicProduct.funcBox.imported")}}</Button>
                <Button v-if="1" type="info" class="addButton" @click="importExcelData(1)" style="margin-right:8px;">{{$t("BasicProduct.funcBox.importedExcel")}}</Button>
                <Button v-if="1" type="primary" class="addButton" @click="savetoexcel" style="margin-right:20px;">{{$t("BasicProduct.funcBox.exportedExcel")}}</Button>
            </div>
        </div>

        <Icon class="colseButton" type="ios-close-circle" size='30' style="color:#ed4014" @click="cancel" />


        <div class="search-div flexC" style="margin-top:30px" v-if="resData.result.length>50">
            <div class="search-div-item flexC">
              <div class="labelText" style="line-height:42px">  {{$t("BasicProduct.funcBox.titleName.Identifier") }}</div>
              <Input  class="input-div"  :placeholder="$t('inputPlaceholder')"  clearable  v-model="searchObj.identifier"></Input>
            </div>

             <div class="search-div-item">
               <Button type="info" @click="searchItem" icon="ios-search" style="margin-top:5px">{{ $t("search") }}</Button>
             </div>
        </div>

        <div>
   
            <TableTemp ref="hyecoTableRef" :dataObj="resData" :searchObj="searchObj"  :dataParams="{keyType:1,communicateProtocol:editFormData.communicateProtocol}"  @addData="setData"></TableTemp>
        </div>

        <!-- 编辑 -->
        <ModelBox :showSetModel.sync="addBox.showSetModel"  :published="editFormData.published || false" :type="type" :basicTypeId='basicTypeId' :pageId="editFormData.pageId" :designImplTypeNum="addBox.designImplTypeNum"  :keyType="addBox.keyType" :funType='addBox.funType' :editFormData="addBox.editFormData" :fn="addBox.callbackFn"></ModelBox>

        <!-- 管理员输入密码 -->
        <AdminModel ref='verifyPwdRef' :showSetModel.sync="adminModelBox.showModel"  :editFormData="adminModelBox.editFormData" :fn="adminModelBox.callbackFn" :loading="adminModelBox.loading"></AdminModel>

         <!-- 导入 -->
         <ImportBox :showSetModel.sync="importBox.showSetModel" :loraProductKey="editFormData.loraProductKey"  :designImplType="editFormData.designImplType" :basicTypeId="basicTypeId"  :fn="importBox.callbackFn"></ImportBox>
    
         <!-- 导入Excel -->
         <ImportExcelBox :showModel.sync="importExcelBox.showSetModel"  dataType="hyeco"   :basicTypeId="basicTypeId" :fn="importExcelBox.callbackFn"></ImportExcelBox>
    
    
        </div>

</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from '@/common/common';
import moment from 'moment';
import * as XLSX from 'xlsx/xlsx.mjs';
import { mapState,mapMutations } from 'vuex'
import TableTemp from "./table.vue"
import ModelBox from './setFuncModel.vue'
import ModelLogBox from './setLogModel.vue'
import ImportBox from './componentImport/importModel.vue'; // 引入导入弹框组件
import ImportExcelBox from './componentImport/importExcelModel.vue'; // 引入导入弹框组件
import AdminModel from './componentOther/showAdminModel.vue';  


    export default {
        props: {
            showModel: Boolean,
            fn:Function,
            editFormData:Object,
        },
        name: "HyecoModelFunc",
        components: {
            TableTemp,
            ModelBox,
            ModelLogBox,
            ImportBox,
            ImportExcelBox,
            AdminModel
        },
        data() {
            return {   
                disabled: false,//禁用确定按钮
                type:1,
                searchObj:{
                    identifier:''
                },
                addBox:{//规格弹框组-新增
                    showSetModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                    funType:'',
                    keyType:0,
                    isGener:false,//是否可以删除，通用的功能和参数新增后不能删除，加了isGener=true， 修改只能改默认值，，没加可以删除
                    designImplTypeNum:0
                },
                adminModelBox:{
                    showModel:false,
                    callbackFn:()=>{}, //弹框的回调函数
                    editFormData:{},//编辑时传入的现有数据
                    loading:false
                },
                LogBox:{//规格弹框组-新增
                    showSetModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                },
                activeName:'1-1',
                formData: {//表单数据
                   
                },
                basicTypeId:null,
                scroll:'',
                resData:{
                    loading:true,
                    published:false,
                    pageId:'',
                    result:[]
                },
                pageID:'',
                wordList:[],
                importBox:{//规格弹框组-新增
                    showSetModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                },
                importExcelBox:{//规格弹框组-新增
                    showSetModel:false,//弹框开关
                    callbackFn:()=>{}, //弹框的回调函数
                },
               
            }
        },
        watch:{
            async showModel(val){
                if(val === true) {   
                    this.pageID = this.editFormData.pageId || this.pageIdStore || ''

                    // console.log('adminModelBox.editFormDataadminModelBox.editFormData',this.editFormData)
                    if(this.editFormData.id){
                        this.basicTypeId = this.editFormData.id
                        // this.addBox.designImplType = this.editFormData.designImplType   //原来，20220328之前
                        // this.addBox.designImplType = this.editFormData.communicateProtocol==1?2:1   //20220328之后，根据协议类型判断    designImplType：2是16进制，1是其他普通
                        this.addBox.designImplTypeNum =  this.editFormData.communicateProtocol==1?2:1   //20231208 改

                        this.resData.pageId = this.editFormData.pageId
                        this.resData.published = this.editFormData.published
                        // await this.getWordList()
                        await this.getData()
                    }
                //    console.log('this.basicClassIdArr',this.editFormData)
                   
                } else { //关闭弹框后要做的处理
                    this.resetForm()
                }
            },
             scroll() {
               this.loadSroll()
             }
        },
        computed:{
             ...mapState(['local','selectId','showLeftPx','pageIdStore']),
             title(){
                let title = this.$t('BasicProduct.funcBox.title')
                return title
             }
        },
       async created(){
        },
        mounted(){
            const scrollview  = this.$refs.contentRef
            if(scrollview){
                scrollview.addEventListener('scroll', this.scrollChange, true)
            }
 
        },
        beforeDestroy() {
            const scrollview = this.$refs.contentRef
            if(scrollview){
                scrollview.removeEventListener('scroll', this.scrollChange, true) 
            }
        },
        methods: {
            ...mapMutations(['setwordListByPageId']),
            setData(data){//、编辑数据
                this.addData(2,data.keyType, data.funType,data.row)
                // console.log('row',row)
            },
          
            addData(type,keyType,funType,row={}){//编辑
                // console.log('99999',{keyType:keyType, funType:funType,row:row})


                this.addBox.showSetModel = true
                this.addBox.funType = ''
                this.addBox.keyType = keyType
                
                this.type = type
                if(type == 2) {
                    this.addBox.editFormData = row

                    this.addBox.editFormData.communicateProtocol = 3
                    this.addBox.editFormData.keyId= row.keyId || row.identifier
                    this.addBox.editFormData.keyName= row.keyName || ""
     
                }
                this.addBox.callbackFn = () => {//回调处理
                    //重新载入
                    this.addBox.showSetModel = false;
                    this.addBox.funType = ''
                    this.addBox.keyType = 0
                    this.getData();
                }
            },
            async  getWordList(){
                this.resData.loading = true
                let params={
                        page:1,
                        limit:100000,
                        pageId:this.editFormData.pageId || this.pageID
                    }
                let  result = await this.axios.post(this.config.urlArray.pagesLangDictionaryList,params)
                if(result){
                    this.wordList = result.data.data.dealersList
                    this.setwordListByPageId(this.wordList)
                }
                
            },
            searchItem(){
                 this.$refs.hyecoTableRef.searchItem()
            },
            async showAdminData() {  //发布后的基础型号修改需要输入管理员密码

                if(!this.editFormData.published){
                   
                    await this.importHyecoIdentifier()
                    return
                }

                 this.adminModelBox.showModel = true
                 this.adminModelBox.callbackFn =async (password) => {//回调处理
                     //重新载入
                     this.adminModelBox.loading = true;
                     await this.importHyecoIdentifier({password:password})
                 }
             },
            async importHyecoIdentifier(params={}){//加载heyceo数据
                
                let paramsObj = {
                    ...params,
                    basicTypeId:this.basicTypeId
                }
                this.resData.loading = true
                let res = await this.axios.post(this.config.urlArray.importHyecoIdentifier,paramsObj)
                this.resData.loading = false
                this.adminModelBox.loading = false;
                // console.log('res',res)


               

                if(res.data.code==1){
                    this.$Message.success(this.$t('successInfo.sync'))
                    this.adminModelBox.showModel = false
                }else{
                    this.$Message.error(res.data.message || this.$t('errorInfo.sync'))
                }

                // console.log('result',result)
            },
            scrollChange(e){//滚动距离
                this.scroll = e.target.scrollTop

            },
            loadSroll(){//根据滚动距离，对应类型active
               let items  = document.querySelectorAll(".scroll-item");
               
               for (var i = 0; i < items.length; i++) {
                   let top = items[i].getBoundingClientRect().top-175
                   let height = items[i].getBoundingClientRect().height
                   if(top+height>0){
                        if(i+1>7){
                            this.activeName = '3'+'-'+(i+1)
                        }else if(i+1>5){
                            this.activeName = '2'+'-'+(i+1)
                        }else{
                            this.activeName = '1'+'-'+(i+1)
                        }
                       break
                   }
                }
            },
           
          
            todelDataHyeco(data){//删除数据

               this.axios.post(this.config.urlArray.delBasicKeys,{id:data.id}).then(result=>{
                    common.ajaxMsg(result.data,true,()=>{
                    
                        this.getData();
                    })
               })
            },
            cancel() {//对话框关闭
                this.$emit('update:showModel',false);
                this.$emit('update:offModel',true);
            },
            resetForm() {//重置表单
                this.searchObj.identifier = ""
                this.resData.result = []
            },
            async getData(){ //获取数据
                if(!this.basicTypeId) return
                let params ={
                    basicTypeId:this.basicTypeId,
                    // serachMajorKey:false
                }
                this.resData.loading = true
               
                let  result = await this.axios.post(this.config.urlArray.getBasicKeys,params)


                if(result.data.code==1){
                    
                    this.resData.result = result.data.data
                    this.resData.result.map((item,index)=>{
                        item.sortVal = index+1
                        if(item.sortNumber!==0 && !item.sortNumber){
                          item.sortNumber = null
                        }
                        return item
                    })

                    this.resData.loading = false
                }else{
                    this.$Message.error(res.data.message)
                    this.resData.loading = false
                }
            },
            importData(type,keyType,funType,row={}){//导入相同机型数据
                this.importBox.showSetModel = true
               
                this.importBox.callbackFn = (flag) => {//回调处理
                    //重新载入
                    this.importBox.showSetModel = false;
                   
                    if(flag){//刷新

                        this.getData();
                    }
                }
            },
            importExcelData(){//导入excel,想达到的目的是，开发环境上编好后，生产环境可以直接导入
                this.importExcelBox.showSetModel = true
              
                this.importExcelBox.callbackFn = () => {
                    //重新载入
                    this.importExcelBox.showSetModel = false;
                    this.getData();
                }
            },
            async savetoexcel(){//导出
                 // 自定义下载的header，注意是数组中的数组哦
                 const Header = [["basicTypeId","chooseToUse","conUiCode","conditionJudgment","defaultValue","descr","formatContent","formatType","id","identifier","keyName","offlineOperation","propertyId","readWrite","remark","required","senseAction","senseCondition","sortNumber","taskUiCode","whetherMajor"]];
                 // 需要导出的数据
                const exportArr = []
                this.resData.result.map(item=>{
                    let obj = {} 
                    Header[0].forEach(key=>{obj[key]=item[key]})
                    exportArr.push(obj)
                })
              
            
                // 将JS数据数组转换为工作表。
                const headerWs = XLSX.utils.aoa_to_sheet(Header);
                const ws = XLSX.utils.sheet_add_json(headerWs, exportArr, {skipHeader: true, origin: 'A2'});
            
                /* 新建空的工作表 */
                const wb = XLSX.utils.book_new();
            
                // 可以自定义下载之后的sheetname
                XLSX.utils.book_append_sheet(wb, ws, 'sheetName');
                
            
                /* 生成xlsx文件 */
                XLSX.writeFile(wb,`basicTypeId${this.basicTypeId}.xlsx` );
            },
        }
    }
</script>

<style lang='less' scoped>

/deep/ .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    .ivu-modal{
        top: 0;
    }
   
}
/deep/ .ivu-input-number{
    width: 100% !important;
}
.verAddCon{
    position: relative;
    .mainTitle{
        font-size: 20px;
        // position: fixed;
        // z-index: 99;
        background-color: #fff;
    }
    .colseButton{
        position: absolute;
        right: -18px;
        top:-18px
    }
    .content{
        margin-left: 240px;
        height: calc(100vh - 230px);
        // overflow-y: scroll;
        overflow: auto;
    }
}
 /deep/ .ivu-form-item-content{
      margin-left: 176px !important;
  }
.logoCon{
  /deep/ .ivu-form-item-content{
      margin-left: 0px !important;
  }
}
 /deep/ .ivu-form .ivu-form-item-label{
    width: 162px !important;
}


.side{
    position: fixed;
    left: 302px;
    top:175px;
    /deep/ .ivu-menu-vertical.ivu-menu-light:after {
      background: #fff;
   }
}


</style>
